import { render, staticRenderFns } from "./listSensorsTankCustomer.vue?vue&type=template&id=59855724"
import script from "./listSensorsTankCustomer.vue?vue&type=script&lang=js"
export * from "./listSensorsTankCustomer.vue?vue&type=script&lang=js"
import style0 from "./listSensorsTankCustomer.vue?vue&type=style&index=0&id=59855724&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports